import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';

@Directive({
  selector: '[hasSubscription]'
})
export class HasSubscriptionDirective implements OnInit, OnDestroy {
  @Input() hasSubscription!: string | string[];
  @Input() hasSubscriptionElse?: TemplateRef<any>;

  private subscription!: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit(): void {
    this.subscription = this.subscriptionService.subscriptionType$.subscribe(() => {
      this.updateView();
    });
    this.updateView();
  }

  private updateView(): void {
    this.viewContainer.clear();
    
    const currentSubscription = this.subscriptionService.getSubscriptionType();
    const allowedSubscriptions = Array.isArray(this.hasSubscription) 
      ? this.hasSubscription 
      : [this.hasSubscription];

    if (allowedSubscriptions.includes(currentSubscription)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.hasSubscriptionElse) {
      this.viewContainer.createEmbeddedView(this.hasSubscriptionElse);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
